// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"1bd20d65","150":"fa277bdb","164":"ea63c3eb","665":"ec23a94e","765":"9c374bc9","952":"4e5ec3ee"}[chunkId] + ".chunk.js";
};